import { Injectable } from '@angular/core';
import { AppRoutes } from '@core/routes/route.paths';
import { SubMenu } from '@shared/model/menu-item.type';

@Injectable({ providedIn: 'root' })
export class SupervisionMenuService {
  getMenu(): SubMenu {
    return {
      root: { label: 'menu.supervision', routerLink: AppRoutes.Supervision.root },
      items: [
        { label: 'main-menu.global-supervision', routerLink: AppRoutes.Supervision.Global },
        {
          label: 'menu.jobs_press',
          routerLink: AppRoutes.Supervision.Press,
        },
      ],
    };
  }
}
